<app-module-layout
    name="Débito Automático"
    description="Aquí podrás enviar un formulario para registrarte en el débito automático, permitiéndonos descontar mensualmente las cuotas sociales pendientes. Así, siempre estarás al día con tus pagos."
    [navigation]="[
        {
            label: ' Mi Afiliación',
            url: '/recurring-payments/',
            iconClass: 'form'
        }
    ]"
></app-module-layout>
